// 判断正式服还是测试服

let myplugin = {
    install: function (Vue) {
        /**
         * @return {string}
         */
        Vue.prototype.getDomain = function () {
            let href = window.location.href;
            if (href.indexOf('localhost') > -1 || href.indexOf('test') > -1) {
                return 'https://txmtest.zidouchat.com/'
            } else if (href.indexOf('wxtxm') > -1) {
                return 'https://txm.zidouchat.com/'
            }
        }
        Vue.prototype.getRedirectDomain = function () {
            let href = window.location.href;
            if (href.indexOf('test') > -1 || href.indexOf('localhost') > -1) {
                return 'https://wxtxmtest.zidouchat.com/'
            } else if (href.indexOf('wxtxm') > -1) {
                return 'https://wxtxm.zidouchat.com/'
            }
        }
    }
}

export default myplugin
